import { render, staticRenderFns } from "./TabsInPills.vue?vue&type=template&id=292df194&"
import script from "./TabsInPills.vue?vue&type=script&lang=ts&"
export * from "./TabsInPills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports